import Navbar from "@/components/Navbar";
import SEO from "@/components/SEO";
import React, { useState } from "react";
import Image from "next/image";
import productHero from "../../../public/images/DSC_6666.jpg";
import Layout from "@/components/Layout";
import Footer from "@/components/Footer";
import ProductCard from "@/components/ProductCard";
import { storefront } from "@/helpers/store";
import { productsQuery } from "@/helpers/queries";
import Pagination from "@/components/Pagination";

function Index({ products }) {
  const [sortOption, setSortOption] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(12);

  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;

  if (!products) return <p>Oops! something went wrong</p>;

  const filteredBoxes = products.filter((product) =>
    product.tags.includes("box")
  );
  const filteredAccessories = products.filter((product) =>
    product.tags.includes("accessory")
  );
  const filteredProducts = [...filteredBoxes, ...filteredAccessories].filter(
    (product) => !product.tags.includes("hidden")
  );

  return (
    <>
      <SEO title="Send a Sloth - Products" />

      <Layout>
        <div className=" space-y-8 lg:space-y-0 flex lg:flex-row flex-col items-center justify-evenly  w-full h-auto py-14 lg:py-24">
          <div className="w-[90%] lg:w-[32%] space-y-4">
            <h1 className="text-[#294870] text-6xl lg:text-7xl font-bold">
              Sloth Gifts
            </h1>
            <p>
              Here are our Sloths and other accessories, choose from a simple
              Gift or treat someone to a gift box!
            </p>
          </div>

          <div className=" flex items-center justify-center w-full lg:w-[40%]">
            <div className="w-full h-auto relative">
              <Image
                className="rounded-2xl"
                src={productHero}
                alt="products listing hero image"
              />
            </div>
          </div>
        </div>

        {/* filter tab */}
        <div className="flex items-center justify-between px-6 bg-white shadow-sm rounded-[14px] w-full h-auto py-4">
          <div className="flex items-center space-x-3">
            <h3 className="font-medium">Featured</h3>
            <p className="text-[#6F6F6F]">{filteredProducts?.length}</p>
          </div>

          <select
            name=""
            id=""
            className="font-medium bg-transparent outline-none"
            value={sortOption}
            onChange={(e) => setSortOption(e.target.value)}
          >
            <option value="">Sort by</option>
            <option value="asc">Asc</option>
            <option value="desc">Desc</option>
            <option value="price-asc">Price &#9650;</option>
            <option value="price-desc">Price &#9660;</option>
          </select>
        </div>

        {/* products list */}

        <div className=" py-8 w-[100%] grid place-content-center place-items-center place-self-center	 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {filteredProducts
            .slice(firstPostIndex, lastPostIndex)
            .sort((a, b) => {
              switch (sortOption) {
                case "asc":
                  return a.title.localeCompare(b.title);
                case "desc":
                  return b.title.localeCompare(a.title);
                case "price-asc":
                  return (
                    a.priceRange.maxVariantPrice.amount -
                    b.priceRange.maxVariantPrice.amount
                  );
                case "price-desc":
                  return (
                    b.priceRange.maxVariantPrice.amount -
                    a.priceRange.maxVariantPrice.amount
                  );
                default:
                  return 0;
              }
            })
            .map((product, key) => (
              <ProductCard
                key={key}
                title={product.title}
                desc={product?.shortDescriptionMetafield?.value}
                handle={product.handle}
                price={product.priceRange.maxVariantPrice.amount}
                img={product.images.edges[0].node.originalSrc}
              />
            ))}
        </div>
        {/* pagination */}

        {filteredProducts.length > postsPerPage ? (
          <Pagination
            totalPosts={filteredProducts.length}
            postsPerPage={postsPerPage}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
          />
        ) : null}

        {/* <div className="cursor-pointer group flex items-center justify-center space-x-6 h-auto py-8">
          <div className="text-gray-500 text-sm flex items-center space-x-1">
            <svg
              width={15}
              height={7}
              viewBox="0 0 15 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="group-hover:fill-[#294870] fill-[#BCBFC2]"
            >
              <path d="M15 4V3H4V0L0 3.5L4 7V4H15Z" />
            </svg>

            <p className="group-hover:text-[#294870]">Prev</p>
          </div>

          <div className="flex items-center space-x-4">
            <div className="h-[24px] w-[1px] bg-gray-500"></div>
            <p className="text-gray-500 ">1</p>
            <div className="h-[24px] w-[1px] bg-gray-500"></div>

            <p className="text-gray-500 ">2</p>
            <div className="h-[24px] w-[1px] bg-gray-500"></div>

            <p className="text-gray-500 ">3</p>
            <div className="h-[24px] w-[1px] bg-gray-500"></div>

            <p className="text-gray-500 ">...</p>
            <div className="h-[24px] w-[1px] bg-gray-500"></div>

            <p className="text-gray-500 ">18</p>
            <div className="h-[24px] w-[1px] bg-gray-500"></div>
          </div> */}

        {/* <div className="cursor-pointer group text-gray-500 text-sm flex items-center space-x-1">
            <p className="group-hover:text-[#294870]">Next</p>
            <svg
              width={15}
              height={7}
              viewBox="0 0 15 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="group-hover:fill-[#294870] fill-[#BCBFC2]"
            >
              <path d="M0 3V4H11V7L15 3.5L11 0V3H0Z" />
            </svg>
          </div>
        </div> */}
      </Layout>
      {/* footer */}
      <Footer />
    </>
  );
}

export default Index;

export async function getStaticProps() {
  try {
    const response = await storefront(productsQuery);

    if (response.errors) {
      console.error(response.errors);
      return {
        props: {
          products: [],
        },
      };
    }

    const products = response.data.products.edges.map(({ node }) => node);

    return {
      props: {
        products,
      },
      revalidate: 60, // Regenerate every 60 seconds (adjust as needed)
    };
  } catch (error) {
    console.error(error);
    return {
      props: {
        products: [],
      },
    };
  }
}
